import React from "react";
import Button from "@material-ui/core/Button";
import { styled } from "@material-ui/core/styles";
import axios from "axios";

const MyButton = styled(Button)({
  background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
  border: 0,
  borderRadius: 3,
  boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
  color: "white",
  height: 40,
  padding: "0 10px",
  fontSize: "1.1rem",
  marginLeft: "1rem",
});

class Card extends React.Component {
  state = {
    modal: false,
    followers: [],
    fError: "",
  };
  toggle = () => {
    this.getFollowers();
    this.setState({ modal: !this.state.modal, followers: [] });
  };

  getFollowers = () => {
    axios
      .get(this.props.usermap.followers_url)
      .then((response) => {
       
        response.data.forEach((item) => {
          axios
            .get("https://api.github.com/users/" + item.login)
            .then((response) => {
              this.setState({
                followers: [...this.state.followers, response.data],
              });
            })
            .catch((error) => {
              console.log("The data was not returned1 ", error);
            });
        });
      })
      .catch((error) => {
        this.setState({
          fError:
            "There are too many requests. It has been blocked by CORS policy. Please try again in one hour.",
        });
        console.log("The data was not returned2 ", error);
      });
  };

  render() {
    return (
      <div className="card">
        <img src={this.props.usermap.avatar_url}  alt={this.props.usermap.name}/>
        <div className="card-info">
          <h3 className="name">{this.props.usermap.name}</h3>
          <p className="username">{`${this.props.usermap.login}`}</p>
          {this.props.usermap.location && 
          <p><span>Location:</span> {` ${this.props.usermap.location}`}</p>}
          <p><span>Profile:</span>
            
            <a href={this.props.usermap.html_url}>
            {` ${this.props.usermap.html_url}`}
            </a>
          </p>
          <p><span>Followers:</span>{` ${this.props.usermap.followers}`};</p>
          <p><span>Following:</span>{` ${this.props.usermap.following}`}</p>
          {this.props.usermap.bio && 
          <p className="bio"><span>Bio:</span>{` ${this.props.usermap.bio}`}</p>}
          <ul className={this.state.modal ? "block" : "none"} style={{marginBottom:"2rem"}}>
            {this.state.followers && <div className="followers"><span>Click on the follower's name to know more:</span></div>}
              {this.state.followers.map((item) => (
                <div
               
                key={item.login}
                >
                  <li
                    className="followers-item"
                    style={{ fontSize: "1.5rem", textAlign: "left" }}
                  >
                    <a
                    style={{color: "black", textDecoration: "none"}}
                      href={item.html_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >{`${item.login}`}</a>
                  </li>
                </div>
              ))}
            </ul>
           
        </div>
        <MyButton onClick={this.toggle} >Followers</MyButton>
        <div className={this.state.modal ? "block" : "none"}>
          <div>
            {this.state.fError && (
              <p style={{ color: "red", fontSize: "2rem", marginTop: "2rem" }}>
                {this.state.fError}
              </p>
            )}
            
          </div>
        </div>
      </div>
    );
  }
}
export default Card;
